module.exports = __webpack_public_path__ + "img/skale.7f9681ec.png";